export default {
  computed: {},
  data() {
    return {};
  },
  methods: {
    emitEventPopup(name, payload) {
      this.$emit("eventPopup", { name, payload });
    },
    eventPopup(payload) {
      this.$emit("eventPopup", payload);
    }
  }
};
